import { SelectedSocialProfileValue } from '../../../components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { MappedProfileType } from '../../../components/socialProfiles/SocialProfileListItem/SocialProfileListItem.view';

export type CardinalSocialProfileType = {
  __typename?: MappedProfileType['__typename'];
  id: MappedProfileType['id'];
};

export const mapProfileFragmentToSelectedSocialProfileValue = (
  profiles: CardinalSocialProfileType[]
): SelectedSocialProfileValue[] =>
  profiles.map(profile => ({
    __typename: profile.__typename,
    profileId: profile.id
    // we can't set selectedBoard since we don't have it, no default board value provided. The same applies for tiktok settings
  }));
